import { baseApi, client } from '../baseApi.ts';

export const subscriptionEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		listPlans: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.subscription.listPlans();
					return { data: response.data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['SubscriptionPlans'],
		}),
	}),
});
